import { Unit } from './unit.model';
import { UnitInterface } from './unit.interface';

export class UnitFactory {

    static empty(): Unit {
        return new Unit('', '', [], '');
    }

    static fromObject(raw: UnitInterface | any): Unit {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new Unit(
            raw.id,
            raw.name,
            raw.buildings || [],
            raw.description,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/units/shared/unit.factory.ts